<template>
  <div class="mob-filters__single">
    <p class="bold-text">{{ title }}</p>
    <ul class="mob-filters__list">
      <YearChoice
          v-if="title === Filter.YEAR"
          class="single-filter__list-item"
          v-for="choice in filter"
          :key="choice.value"
          :choice="choice"/>
      <AltitudeChoice
          v-else-if="title === Filter.ALTITUDE"
          class="single-filter__list-item"
          v-for="choice in filter"
          :key="choice.value"
          :choice="choice"
      />
      <MediaChoice
          v-else-if="title === Filter.MEDIA"
          class="single-filter__list-item"
          v-for="choice in filter"
          :key="choice.value"
          :choice="choice"
      />
      <SpecificChoice
          v-else-if="title === Filter.SPECIFIC"
          class="single-filter__list-item"
          v-for="choice in filter"
          :key="choice.value"
          :choice="choice"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import {Category, Filter} from "../../../utils/types.ts";
import AltitudeChoice from "./AltitudeChoice.vue";
import YearChoice from "./YearChoice.vue";
import SpecificChoice from "./SpecificChoice.vue";
import MediaChoice from "./MediaChoice.vue";

interface Props {
  title: Filter;
  filter: Category[];
}

defineProps<Props>();
</script>
